import { DATE_FORMATS, Gender, GenderLabel, POSSIBLE_DATE_FORMATS, TableTitles } from "@/constants";
import { cn } from "@/libs/cn";
import { Divider, Image } from "antd";
import dayjs from "dayjs";

export function RegistrantInformations({
    registrant,
}: {
    registrant: Meditator;
}) {
    return (
        <div
            className="rounded shadow border border-black/10 p-4"
        >
            <h2
                className="text-base font-semibold"
            >
                ယောဂီ အချက်အလက်
            </h2>
            <Divider />
            <div
                className="grid grid-cols-2 gap-6"
            >
                <DataItem
                    title={TableTitles.registrant_book_id}
                    value={registrant.book?.bookNo}
                />
                <DataItem
                    title={TableTitles.retreat_level}
                    value={registrant.level.name}
                />
                <DataItem
                    title={TableTitles.registrant_name}
                    value={registrant.name}
                />
                <DataItem
                    title={TableTitles.registrant_nrc}
                    value={registrant.nrcNo}
                />
                <DataItem
                    title={TableTitles.registrant_father_name}
                    value={registrant?.fatherName}
                />
                <DataItem
                    title={TableTitles.registrant_dob}
                    value={registrant?.dob ? dayjs(registrant?.dob, Array.from(POSSIBLE_DATE_FORMATS)).format(DATE_FORMATS.DEFAULT_DISPLAY_DATE) : "N/A"}
                />
                <DataItem
                    title={TableTitles.registrant_phone}
                    value={registrant.phone}
                />
                <DataItem
                    title={"Email Address"}
                    value={registrant.email}
                />
                <DataItem
                    title={TableTitles.registrant_gender}
                    value={GenderLabel[registrant.yogiType as Gender]}
                />
                <DataItem
                    title={TableTitles.city}
                    value={registrant?.township}
                />
                <DataItem
                    title={TableTitles.state}
                    value={registrant?.state}
                />
                <DataItem
                    title={TableTitles.registrant_address}
                    value={registrant.address}
                />
                <DataItem
                    title={"Note"}
                    value={registrant.note}
                    className="col-span-2"
                />
                <DataItem
                    title={TableTitles.registrant_medical_history}
                    value={registrant.previousIllnesses}
                    className="col-span-2"
                />
                <DataItem
                    title={TableTitles.registrant_current_health_condition}
                    value={registrant.currentMedicalCondition}
                    className=" col-span-2"
                />
                <DataItem
                    title={TableTitles.previous_attended_retreats}
                    value={registrant.previousMeditationCenter}
                    className=" col-span-2"
                />

                <DataItem
                    title={TableTitles.registrant_half_body_photo}
                    isImageItem={true}
                    imgUrl={registrant.profileUrl ?? "https://adaptcommunitynetwork.org/wp-content/uploads/2023/09/person-placeholder.jpg"}
                />

                <div
                    className="space-y-2"
                >
                    <h2
                        className="text-base"
                    >
                        မှတ်ပုံတင်
                    </h2>
                    <div
                        className="grid grid-cols-2 gap-4"
                    >
                        <DataItem
                            isImageItem={true}
                            imgUrl={registrant?.nrcFront ?? "https://adaptcommunitynetwork.org/wp-content/uploads/2023/09/person-placeholder.jpg"}
                        />
                        <DataItem
                            isImageItem={true}
                            imgUrl={registrant?.nrcBack ?? "https://adaptcommunitynetwork.org/wp-content/uploads/2023/09/person-placeholder.jpg"}
                        />
                    </div>
                </div>

            </div>
        </div>
    )
}


const DataItem = ({
    title,
    className,
    value,
    isImageItem = false,
    imgUrl
}: {
    title?: string,
    value?: string | null,
    className?: string,
    isImageItem?: boolean,
    imgUrl?: string
}) => {

    return (
        <div
            className={cn(className, "space-y-2")}
        >
            {
                title && (
                    <h2
                        className="text-base"
                    >
                        {title}
                    </h2>
                )
            }

            {
                isImageItem ? (
                    <Image
                        src={imgUrl}
                        alt="Registrant Image"
                        className="w-full h-full object-cover rounded-md aspect-video [&~.ant-image-mask]:!rounded-md "
                    />
                ) : (
                    <p
                        className="p-2 border rounded-sm border-black/50 font-poppins bg-black/[0.05]"
                    >
                        {value || "N/A"}
                    </p>
                )
            }
        </div>
    )
}